import { FILE_SHARE } from '../ids';
import { InstallLocation } from '../types';
export const ids = FILE_SHARE;
export const getDefinition = (staticsUrl, t) => ({
    ...FILE_SHARE,
    installLocation: InstallLocation.Profile,
    method: 'addSection',
    urlOverride: 'my-files',
    social: true,
    menuOrder: 2,
    page: {
        name: t('fileshare_page_name'),
        shortDescription: t('fileshare_page_short_description'),
        description: t('fileshare_page_description'),
        origin: t('fileshare_origin'),
        iconURL: `${staticsUrl}assets/images/icons/file-share-icon.png`,
        screenshots: [
            `${staticsUrl}assets/images/file-share/file-share.png`,
            `${staticsUrl}assets/images/file-share/mobile-file-share.png`,
        ],
    },
});
//# sourceMappingURL=file-share.js.map